import { ExpenseEntryGridConfigModel } from "app/core/mips/common/models/expense-entry-grid-config.model";

export interface ExpenseEntryGridConfig {
    expenseEntryGridConfig: ExpenseEntryGridConfigModel | null;
}

export const initialExpenseEntryGridConfigModel: ExpenseEntryGridConfig = {
    expenseEntryGridConfig: null
};
  